module.exports = __webpack_public_path__ + "img/people_tk.795fdaff.png";